import React, { useState } from "react";
import { useSellerAuth } from "../../context/SellerAuthContext";
import { useNavigate } from "react-router-dom";

const PasswordInputStep = () => {
  const { registrationData, setRegistrationData, registerSeller } =
    useSellerAuth();
  const [password, setPassword] = useState(registrationData.password);
  const navigate = useNavigate();

  // const handleNext = async () => {
  //   setRegistrationData({ ...registrationData, password });
  //   await registerSeller(registrationData.email, password);
  //   navigate("/register/phone");
  // };

  const handleNext = async () => {
    try {
      setRegistrationData({ ...registrationData, password });
      await registerSeller(registrationData.email, password);
      navigate("/register/phone");
    } catch (error) {
      if (error.message.includes("email-already-in-use")) {
        alert("This email is already in use. Please log in instead.");
      } else {
        alert("Registration failed. Please try again.");
      }
    }
  };

  return (
    <div className="p-4">
      <h1 className="text-xl">Create your password</h1>
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="w-full p-2 mt-2 border rounded"
      />
      <button
        onClick={handleNext}
        className="mt-4 p-2 bg-blue-500 text-white rounded"
      >
        Next
      </button>
    </div>
  );
};

export default PasswordInputStep;
